'use client';

import React from 'react';

const items = [
  {
    letter: 'A',
    title: 'Agent Marketplace & Composer',
    icon: '🧩',
    body:
      'Pre-built agents out of the box — Leasing, Maintenance, Collections. Customize via no-code drag-drop. Build your own. Partners publish certified agents to a marketplace.',
    tech: 'Temporal / Inngest + LLM function-calling + MCP',
    ref: 'Yardi Virtuoso Marketplace + Composer (Sept 2025)',
  },
  {
    letter: 'B',
    title: 'Model Context Protocol (MCP)',
    icon: '🔌',
    body:
      'Bring your own LLM — Claude, GPT-4, Gemini, on-prem Llama. Sensitive data stays in Propmatic; only what the LLM needs is exposed. BYOAA workflows.',
    tech: 'MCP server + scoped tool exposure',
    ref: 'Anthropic Claude + Yardi Virtuoso Connectors',
  },
  {
    letter: 'C',
    title: 'Document Intelligence Platform',
    icon: '📑',
    body:
      'Any document — lease, invoice, utility bill, insurance cert, tax form, ID — parsed, extracted into structured tables, and routed to the right workflow.',
    tech: 'Multi-modal LLM + OCR fallback + classification',
    ref: 'MRI Forms Intelligence',
  },
  {
    letter: 'D',
    title: 'Voice Interface',
    icon: '🎙',
    body:
      'PM on-site: "Log work order: Unit 4B, leak under sink, high priority." Tenants complete tasks by voice. Inbound leasing calls handled by AI receptionist 24/7.',
    tech: 'Speech-to-text + LLM + text-to-speech',
    ref: 'Mobile-first UX; after-hours coverage',
  },
  {
    letter: 'E',
    title: 'Smart Search Everywhere',
    icon: '🔎',
    body:
      '"Show me tenants behind on rent with small children." "Find leases expiring in Cape Town with rent over R50,000." Natural language across the whole graph.',
    tech: 'Semantic search (pgvector / Pinecone) + LLM parser',
    ref: 'MRI Ask Agora pattern',
  },
];

export default function AICrossCutting() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="reveal-blur mb-12 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[rgba(124,58,237,0.25)] mb-5">
            <span className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
              Cross-Cutting Capabilities
            </span>
          </div>
          <h2
            className="font-manrope font-extrabold tracking-tighter text-[#EEEEF0]"
            style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}
          >
            Five primitives.
            <br />
            <span
              style={{
                background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Every feature uses them.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 stagger-children">
          {items.map((it, i) => (
            <div
              key={it.letter}
              className={`reveal-blur bento-card card-shine p-7 flex gap-5 ${
                i === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div className="flex flex-col items-center gap-3 shrink-0">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center font-manrope font-extrabold text-lg"
                  style={{
                    background: 'linear-gradient(135deg, rgba(124,58,237,0.2), rgba(167,139,250,0.1))',
                    border: '1px solid rgba(124,58,237,0.35)',
                    color: '#A78BFA',
                  }}
                >
                  {it.letter}
                </div>
                <div className="text-2xl">{it.icon}</div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-manrope font-bold text-lg text-[#EEEEF0] tracking-tight">
                  {it.title}
                </h3>
                <p className="text-sm text-[#9999A8] mt-2 leading-relaxed">{it.body}</p>
                <div className="mt-4 pt-3 border-t border-[rgba(255,255,255,0.05)] flex flex-col gap-1">
                  <div className="text-[10px] font-mono text-[#5A5A6E]">
                    <span className="text-[#5A5A6E]">TECH · </span>
                    <span className="text-[#9999A8]">{it.tech}</span>
                  </div>
                  <div className="text-[10px] font-mono text-[#5A5A6E]">
                    <span className="text-[#5A5A6E]">REF · </span>
                    <span className="text-[#A78BFA]">{it.ref}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
